/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Setting_Not_WithdrawableInputs */

const en_error_allocation_setting_not_withdrawable = /** @type {(inputs: Error_Allocation_Setting_Not_WithdrawableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This change already applies: it can no longer be withdrawn.`)
};

/**
* | output |
* | --- |
* | "This change already applies: it can no longer be withdrawn." |
*
* @param {Error_Allocation_Setting_Not_WithdrawableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_setting_not_withdrawable = /** @type {((inputs?: Error_Allocation_Setting_Not_WithdrawableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Setting_Not_WithdrawableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_setting_not_withdrawable(inputs)
});